import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll to top on route change.
 * React Router does NOT reset scroll position by default — mount this
 * once inside <BrowserRouter> to fix every internal navigation.
 */
const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        // Use the 2-arg form — universally supported and always instant.
        // 'behavior:instant' throws in older iOS Safari and can silently
        // break route transitions on real mobile devices.
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

export default ScrollToTop;
